import type { ComponentType, FC, ReactNode } from "react";

import styles from "./IconWrapper.module.scss";

export type IconWrapperProps = {
  customIcon?: ReactNode;
  icon?: ComponentType;
};

export const IconWrapper: FC<IconWrapperProps> = ({ customIcon, icon: Icon }) => {
  if (customIcon) {
    return customIcon;
  }

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles.iconWrapper}>
      <Icon />
    </div>
  );
};
